import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataAnalysisApiService {

  private endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }

  getSaleReportByDate(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/sale-daily-report/date`, { params: filters }));
  }

  getSaleReportBranchByDate(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/sale-daily-report/branch/date`, { params: filters }));
  }

  getProductSummaryReport(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-daily-report/summary`, { params: filters }));
  }

  getSaleReportByDateRange(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/sale-daily-report/between`, { params: filters }));
  }

  getProductDailyReport(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-daily-report/all`, { params: filters }));
  }

  searchProduct(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/search`, { params: filters }));
  }

  getAllProduct(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/all`, { params: filters }));
  }

  getAllProductSet(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set/all`, { params: filters }));
  }

  getAllProductSetTikTok(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/tiktok-set/all`, { params: filters }));
  }

  searchProductSet(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set/search`, { params: filters }));
  }

  getProductSetSummaryReport(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set-daily-report/summary`, { params: filters }));
  }

  getProductSetDailyReport(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set-daily-report/all`, { params: filters }));
  }

  getStockBySku(body: { sku: string[]; channel: string[] }) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product-platform/get/stock/summary`, body));
  }

  getStockDetail(body: { sku: string; channel: string[] }) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product-platform/get/stock/detail`, body));
  }

  getRestockReport(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-daily-report/restock`, { params: filters }));
  }

}
